var map = {
	"./BANK.mp3": "5945",
	"./BANKIER.mp3": "d28b",
	"./BANKOMAT.mp3": "d7ec",
	"./BUDZET_2.mp3": "4397",
	"./GOTOWKA.mp3": "01bb",
	"./HOLOGRAM.mp3": "d425",
	"./INWESTYCJA.mp3": "eccc",
	"./KARTA_PLATNICZA.mp3": "2288",
	"./KIESZONKOWE_2.mp3": "938b",
	"./KONTO.mp3": "b40a",
	"./KONTO_BANKOWE.mp3": "c0e4",
	"./LIMIT_1.mp3": "8e5d",
	"./MENNICA.mp3": "044a",
	"./NUMER_PIN.mp3": "d4c4",
	"./OSZCZEDNOSCI.mp3": "d89f",
	"./PIENIADZ.mp3": "9a45",
	"./PLATNOSCI_ZBLIZENIOWE.mp3": "7e77",
	"./POZYCZKA.mp3": "7cd0",
	"./PREMIA.mp3": "f5b7",
	"./PRZELEW_INTERNETOWY.mp3": "12be",
	"./SALDO.mp3": "a6e4",
	"./TERMINAL_PLATNICZY.mp3": "be2a",
	"./TRANSAKCJA_2.mp3": "2028",
	"./WALUTA.mp3": "6a00",
	"./poziom-trudny/BNP_Samodzielniak_Bankoslowka_APLIKACJA_BANKOWA.mp3": "2875",
	"./poziom-trudny/BNP_Samodzielniak_Bankoslowka_KARTA_KREDYTOWA.mp3": "5a3f",
	"./poziom-trudny/BNP_Samodzielniak_Bankoslowka_NR_KONTA.mp3": "9e6a",
	"./poziom-trudny/BNP_Samodzielniak_Bankoslowka_POZYCZKA.mp3": "d74b",
	"./poziom-trudny/BNP_Samodzielniak_Bankoslowka_PRZELEW_NA_TEL.mp3": "30dc",
	"./poziom-trudny/BNP_Samodzielniak_Bankoslowka_SALDO_2.mp3": "9393",
	"./poziom-trudny/BNP_Samodzielniak_Bankoslowka_WYCIAG_Z_KONTA.mp3": "5e97",
	"./poziom-trudny/BNP_Samodzielniak_Bankoslowka_WYTWORNIA_PAPIEROW.mp3": "292a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "429e";